/**
 * 文字数以上以下エラー
 * 最小最大両方 → XXはN文字以上N文字以下で入力してください。
 * 最小のみ    → XXはN文字以上で入力してください。
 * 最大のみ    → XXはN文字以下で入力してください。
 * @param value 文字数
 * @param min 最小文字数
 * @param max 最大文字数
 * @param isNum 数字 or not（数字の場合は単位が桁、notの場合は単位が文字になる）
 * @returns
 */
export function generateWordCountError(
  value: string,
  min: number | undefined,
  max: number | undefined,
  isNum: boolean = false,
): string {
  const unit = isNum ? '桁' : '文字';
  if (!max) {
    // maxが空の場合はmin文字以上だけ表示
    return `${value}は${min}${unit}以上で入力してください。`;
  }
  if (!min) {
    // minが空の場合はmax文字以上だけ表示
    return `${value}は${max}${unit}以下で入力してください。`;
  }
  // min, max両方もってる場合は両方だす
  return `${value}は${min}~${max}${unit}で入力してください。`;
}

/**
 * 汎用的なバリデーション
 */
export const GENERAL_VALIDATION_MESSAGE = {
  EMPTY: 'が入力されていません。',
  NOT_SELECT: 'が選択されていません。',
  FULL_WIDTH: 'に全角文字が含まれています。',
  DEPENDENT_CHARACTER: 'に不正な文字が含まれています。',
  ONLY_HALF_WIDTH: 'は半角で入力してください。',
  ONLY_HALF_WIDTH_NUMBER: 'は半角数字で入力してください。',
  ONLY_HALF_WIDTH_LETTER_NUMBER: 'は半角英数字で入力してください。',
  GENERAL_VALIDATION_ERROR: 'が不正な形式です。',
  INVALID_CHAR_ERROR: 'に不正な文字が含まれています。',
  NOT_HIRAGANA_ERROR: 'はひらがなで入力してください。',
  NOT_KATAKANA_ERROR: 'はカタカナで入力してください。',
};

/**
 * 特定のバリデーション
 */
export const SPECIFY_VALIDATION_MESSAGE = {
  POSTAL_NUMBER: {
    WORD_COUNT_ERROR: '郵便番号は7桁で入力してください。',
  },
  EMAIL: {
    VALIDATION_ERROR: 'メールアドレスを正しく入力してください。',
  },
  USER_NAME: {
    ALL_NUM_ERROR: '9~10桁の数字はユーザー名に利用できません。',
    VALIDATION_ERROR:
      'ユーザー名に使用できる文字は、半角数字、半角英小文字、半角ハイフン（-）、半角ドット（.）、半角アンダースコア(_)のみです。',
    DUPLICATE_USER_ID: 'ユーザー名はすでに使用されています。',
  },
  PASSWORD: {
    VALIDATION_ERROR: 'パスワードは半角アルファベットと半角数字をそれぞれ1文字以上入れてください。',
    NOT_MATCH: 'パスワードが一致しません。',
    INCLUDE_USER_NAME: 'パスワードにユーザー名と同じ文字列を含むことはできません。',
    INCLUDE_EMAIL_ACCOUNT: 'パスワードにメールアドレスと同じ文字列を含むことはできません。',
  },
  SCHOOL_NAME: {
    VALIDATION_ERROR: '入力時に表示される候補の中から必ず１つ選択してください。',
  },
};
